export default {
      id: "oc-more-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-more",
      toString: function () {
        return this.url;
      }
    }